module.exports = __webpack_public_path__ + "img/icon3.e2673733.svg";